export const types = {
    SET: 'SET',
    GET: 'GET',
    DELETE: 'DELETE',
    EXISTS: 'EXISTS',
    GETTTL: 'GET-TTL',
    SETTTL: 'SET-TTL',
    PREPEND: 'PREPEND',
    APPEND: 'APPEND'
};